import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=679ebd20&scoped=true"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=679ebd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ebd20",
  null
  
)

export default component.exports